var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGetOnGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      isolation: "isolate"
    },
    viewBox: "0 0 135 40",
    width: "135pt",
    height: "40pt",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "_clipPath_9esVWX7zuZlo8NDShSVE0EIq0fmT4YaD"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 135,
    height: 40
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#_clipPath_9esVWX7zuZlo8NDShSVE0EIq0fmT4YaD)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 5 0 L 130 0 C 132.76 0 135 2.24 135 5 L 135 35 C 135 37.76 132.76 40 130 40 L 5 40 C 2.24 40 0 37.76 0 35 L 0 5 C 0 2.24 2.24 0 5 0 Z",
    style: {
      stroke: "none",
      fill: "#000000",
      strokeMiterlimit: 10
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: " M 130 0.8 C 132.32 0.8 134.2 2.68 134.2 5 L 134.2 35 C 134.2 37.32 132.32 39.2 130 39.2 L 5 39.2 C 3.886 39.2 2.818 38.758 2.03 37.97 C 1.242 37.182 0.8 36.114 0.8 35 L 0.8 5 C 0.8 2.68 2.68 0.8 5 0.8 L 130 0.8 Z  M 130 0 L 5 0 C 2.239 0 0 2.239 0 5 L 0 35 C 0 37.761 2.239 40 5 40 L 130 40 C 132.761 40 135 37.761 135 35 L 135 5 C 135 2.239 132.761 0 130 0 Z ",
    fill: "rgb(166,166,166)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: " M 47.42 10.24 C 47.454 10.981 47.183 11.704 46.67 12.24 C 46.096 12.836 45.296 13.159 44.47 13.13 C 43.202 13.12 42.064 12.351 41.582 11.179 C 41.099 10.007 41.367 8.659 42.26 7.76 C 42.841 7.167 43.641 6.842 44.47 6.86 C 44.893 6.859 45.311 6.944 45.7 7.11 C 46.062 7.256 46.384 7.486 46.64 7.78 L 46.11 8.31 C 45.705 7.829 45.098 7.566 44.47 7.6 C 43.839 7.597 43.234 7.851 42.794 8.304 C 42.354 8.757 42.118 9.369 42.14 10 C 42.127 10.953 42.688 11.821 43.563 12.199 C 44.438 12.578 45.455 12.393 46.14 11.73 C 46.448 11.397 46.625 10.964 46.64 10.51 L 44.47 10.51 L 44.47 9.79 L 47.38 9.79 C 47.407 9.939 47.42 10.089 47.42 10.24 L 47.42 10.24 Z  M 52 7.74 L 49.3 7.74 L 49.3 9.64 L 51.76 9.64 L 51.76 10.36 L 49.3 10.36 L 49.3 12.26 L 52 12.26 L 52 13 L 48.5 13 L 48.5 7 L 52 7 L 52 7.74 Z  M 55.28 13 L 54.51 13 L 54.51 7.74 L 52.83 7.74 L 52.83 7 L 57 7 L 57 7.74 L 55.28 7.74 L 55.28 13 Z  M 59.94 13 L 59.94 7 L 60.71 7 L 60.71 13 L 59.94 13 Z  M 64.13 13 L 63.36 13 L 63.36 7.74 L 61.68 7.74 L 61.68 7 L 65.8 7 L 65.8 7.74 L 64.13 7.74 L 64.13 13 Z  M 73.61 12.22 C 72.393 13.43 70.427 13.43 69.21 12.22 C 68.03 10.971 68.03 9.019 69.21 7.77 C 69.792 7.184 70.584 6.854 71.41 6.854 C 72.236 6.854 73.028 7.184 73.61 7.77 C 74.795 9.017 74.795 10.973 73.61 12.22 Z  M 69.78 11.72 C 70.681 12.618 72.139 12.618 73.04 11.72 C 73.925 10.744 73.925 9.256 73.04 8.28 C 72.139 7.382 70.681 7.382 69.78 8.28 C 68.895 9.256 68.895 10.744 69.78 11.72 Z  M 75.58 13 L 75.58 7 L 76.52 7 L 79.44 11.67 L 79.44 7 L 80.21 7 L 80.21 13 L 79.41 13 L 76.36 8.11 L 76.36 13 L 75.58 13 Z ",
    fill: "rgb(255,255,255)",
    vectorEffect: "non-scaling-stroke",
    strokeWidth: 0.2,
    stroke: "rgb(255,255,255)",
    strokeLinejoin: "miter",
    strokeLinecap: "butt",
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: " M 68.14 21.75 C 65.795 21.761 63.903 23.669 63.91 26.013 C 63.917 28.358 65.822 30.254 68.167 30.25 C 70.511 30.246 72.41 28.345 72.41 26 C 72.426 24.864 71.981 23.771 71.176 22.97 C 70.371 22.168 69.276 21.728 68.14 21.75 Z  M 68.14 28.58 C 67.083 28.654 66.089 28.074 65.632 27.118 C 65.175 26.163 65.349 25.025 66.071 24.249 C 66.792 23.473 67.915 23.218 68.901 23.604 C 69.888 23.991 70.537 24.941 70.54 26 C 70.573 26.663 70.336 27.31 69.884 27.796 C 69.432 28.282 68.803 28.565 68.14 28.58 Z  M 58.83 21.75 C 56.484 21.756 54.586 23.661 54.59 26.007 C 54.594 28.353 56.497 30.252 58.843 30.25 C 61.189 30.248 63.09 28.346 63.09 26 C 63.106 24.864 62.661 23.771 61.856 22.97 C 61.051 22.168 59.956 21.728 58.82 21.75 L 58.83 21.75 Z  M 58.83 28.58 C 57.773 28.658 56.775 28.081 56.315 27.126 C 55.855 26.171 56.027 25.031 56.747 24.254 C 57.468 23.476 58.591 23.218 59.578 23.604 C 60.566 23.989 61.217 24.94 61.22 26 C 61.253 26.663 61.016 27.31 60.564 27.796 C 60.112 28.282 59.483 28.565 58.82 28.58 L 58.83 28.58 Z  M 47.74 23.06 L 47.74 24.86 L 52.06 24.86 C 51.992 25.708 51.64 26.508 51.06 27.13 C 50.186 28.02 48.977 28.5 47.73 28.45 C 45.079 28.45 42.93 26.301 42.93 23.65 C 42.93 20.999 45.079 18.85 47.73 18.85 C 48.948 18.83 50.124 19.294 51 20.14 L 52.27 18.87 C 51.075 17.66 49.441 16.985 47.74 17 C 45.319 16.906 43.04 18.144 41.802 20.226 C 40.563 22.308 40.563 24.902 41.802 26.984 C 43.04 29.066 45.319 30.304 47.74 30.21 C 49.472 30.288 51.153 29.614 52.35 28.36 C 53.398 27.209 53.957 25.696 53.91 24.14 C 53.913 23.761 53.88 23.383 53.81 23.01 L 47.74 23.06 Z  M 93.05 24.46 C 92.516 22.889 91.068 21.811 89.41 21.75 C 88.304 21.748 87.247 22.203 86.489 23.009 C 85.732 23.814 85.341 24.897 85.41 26 C 85.385 27.129 85.821 28.22 86.617 29.022 C 87.413 29.823 88.501 30.267 89.63 30.25 C 91.051 30.258 92.381 29.551 93.17 28.37 L 91.72 27.37 C 91.28 28.104 90.486 28.552 89.63 28.55 C 88.744 28.584 87.927 28.072 87.57 27.26 L 93.26 24.91 L 93.05 24.46 Z  M 87.25 25.88 C 87.209 25.255 87.421 24.64 87.839 24.174 C 88.257 23.707 88.844 23.428 89.47 23.4 C 90.129 23.357 90.751 23.711 91.05 24.3 L 87.25 25.88 Z  M 82.63 30 L 84.5 30 L 84.5 17.5 L 82.63 17.5 L 82.63 30 Z  M 79.57 22.7 L 79.5 22.7 C 78.93 22.063 78.115 21.699 77.26 21.7 C 74.99 21.81 73.206 23.682 73.206 25.955 C 73.206 28.228 74.99 30.1 77.26 30.21 C 78.118 30.224 78.938 29.858 79.5 29.21 L 79.56 29.21 L 79.56 29.82 C 79.56 31.45 78.69 32.32 77.29 32.32 C 76.336 32.298 75.491 31.701 75.15 30.81 L 73.52 31.49 C 74.148 33.017 75.639 34.01 77.29 34 C 79.48 34 81.29 32.71 81.29 29.57 L 81.29 22 L 79.57 22 L 79.57 22.7 Z  M 77.43 28.58 C 76.093 28.462 75.067 27.342 75.067 26 C 75.067 24.658 76.093 23.538 77.43 23.42 C 78.076 23.453 78.681 23.746 79.109 24.231 C 79.536 24.717 79.749 25.355 79.7 26 C 79.755 26.648 79.543 27.29 79.112 27.778 C 78.681 28.265 78.07 28.555 77.42 28.58 L 77.43 28.58 Z  M 101.81 17.5 L 97.34 17.5 L 97.34 30 L 99.21 30 L 99.21 25.26 L 101.82 25.26 C 103.273 25.364 104.662 24.649 105.42 23.405 C 106.178 22.161 106.178 20.599 105.42 19.355 C 104.662 18.111 103.273 17.396 101.82 17.5 L 101.81 17.5 Z  M 101.81 23.5 L 99.2 23.5 L 99.2 19.24 L 101.85 19.24 C 102.616 19.24 103.324 19.649 103.708 20.312 C 104.091 20.976 104.091 21.794 103.708 22.458 C 103.324 23.121 102.616 23.53 101.85 23.53 L 101.81 23.5 Z  M 113.34 21.7 C 111.949 21.617 110.641 22.367 110.01 23.61 L 111.67 24.3 C 112.004 23.684 112.671 23.323 113.37 23.38 C 113.85 23.324 114.331 23.463 114.708 23.766 C 115.084 24.068 115.322 24.51 115.37 24.99 L 115.37 25.12 C 114.769 24.802 114.1 24.637 113.42 24.64 C 111.63 24.64 109.82 25.64 109.82 27.45 C 109.856 28.23 110.205 28.962 110.789 29.48 C 111.373 29.998 112.142 30.258 112.92 30.2 C 113.879 30.269 114.8 29.809 115.32 29 L 115.38 29 L 115.38 30 L 117.18 30 L 117.18 25.19 C 117.18 23 115.52 21.73 113.39 21.73 L 113.34 21.7 Z  M 113.11 28.55 C 112.5 28.55 111.65 28.24 111.65 27.49 C 111.65 26.49 112.71 26.16 113.65 26.16 C 114.244 26.145 114.831 26.29 115.35 26.58 C 115.221 27.699 114.287 28.553 113.16 28.58 L 113.11 28.55 Z  M 123.74 22 L 121.6 27.42 L 121.54 27.42 L 119.32 22 L 117.32 22 L 120.65 29.58 L 118.75 33.79 L 120.7 33.79 L 125.82 22 L 123.74 22 Z  M 106.93 30 L 108.8 30 L 108.8 17.5 L 106.93 17.5 L 106.93 30 Z ",
    fill: "rgb(255,255,255)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_0",
    x1: 0.9148842803787565,
    y1: 0.0494812450119716,
    x2: -0.11812140826117168,
    y2: 1.0824869336518992,
    gradientTransform: "matrix(12.924,0,0,25.06,9.976,7.47)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,160,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,161,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "26%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,190,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "51%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,210,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "76%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,223,255)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,227,255)"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: " M 10.44 7.54 C 10.114 7.931 9.95 8.432 9.98 8.94 L 9.98 31.06 C 9.95 31.568 10.114 32.069 10.44 32.46 L 10.51 32.53 L 22.9 20.15 L 22.9 19.86 L 10.51 7.47 L 10.44 7.54 Z ",
    fill: "url(#_lgradient_0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_1",
    x1: 1.0768472906403947,
    y1: 0.49999999999999956,
    x2: -1.3064039408866992,
    y2: 0.4999999999999993,
    gradientTransform: "matrix(10.15,0,0,8.56,22.9,15.72)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,224,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "41%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,189,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "78%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,165,0)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,156,0)"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: " M 27 24.28 L 22.9 20.15 L 22.9 19.86 L 27 15.72 L 27.09 15.77 L 32 18.56 C 33.4 19.35 33.4 20.65 32 21.45 L 27.11 24.23 L 27 24.28 Z ",
    fill: "url(#_lgradient_1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_2",
    x1: 0.8621929298981426,
    y1: 0.17876888949130665,
    x2: -0.5014979029358899,
    y2: 1.5418605611509835,
    gradientTransform: "matrix(16.69,0,0,12.866,10.44,20)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(255,58,68)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(195,17,98)"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: " M 27.12 24.22 L 22.9 20 L 10.44 32.46 C 11.029 32.978 11.902 33.003 12.52 32.52 L 27.13 24.22",
    fill: "url(#_lgradient_2)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "_lgradient_3",
    x1: -0.1875374475733973,
    y1: -0.5405214737902952,
    x2: 0.42121030557219896,
    y2: 0.06822627935530134,
    gradientTransform: "matrix(16.69,0,0,12.866,10.43,7.134)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(50,160,113)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "7.000000000000001%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(45,167,113)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "48%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(21,207,116)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(6,231,117)"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopOpacity: 1,
    style: {
      stopColor: "rgb(0,240,118)"
    }
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: " M 27.12 15.78 L 12.51 7.48 C 11.892 6.997 11.019 7.022 10.43 7.54 L 22.9 20 L 27.12 15.78 Z ",
    fill: "url(#_lgradient_3)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 27 24.13 L 12.51 32.38 C 11.917 32.823 11.103 32.823 10.51 32.38 L 10.44 32.45 L 10.51 32.52 C 11.102 32.967 11.918 32.967 12.51 32.52 L 27.12 24.22 L 27 24.13 Z ",
    fill: "rgb(0,0,0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 10.44 32.32 C 10.114 31.929 9.95 31.428 9.98 30.92 L 9.98 31.07 C 9.95 31.578 10.114 32.079 10.44 32.47 L 10.51 32.4 L 10.44 32.32 Z  M 32 21.3 L 27 24.13 L 27.09 24.22 L 32 21.44 C 32.567 21.174 32.948 20.624 33 20 C 32.886 20.565 32.517 21.045 32 21.3 Z ",
    fill: "rgb(0,0,0)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.25
  }, /*#__PURE__*/React.createElement("path", {
    d: " M 12.51 7.62 L 32 18.7 C 32.517 18.955 32.886 19.435 33 20 C 32.948 19.376 32.567 18.826 32 18.56 L 12.51 7.48 C 11.11 6.69 9.97 7.35 9.97 8.95 L 9.97 9.1 C 10 7.49 11.12 6.83 12.51 7.62 Z ",
    fill: "rgb(255,255,255)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetOnGooglePlay);
export default __webpack_public_path__ + "static/media/GetOnGooglePlay.def818b013a2d30bcc5a83a24f95fdbd.svg";
export { ForwardRef as ReactComponent };